import styles from './BackSaveContinueButton.module.css'
const ContinueButton = ({
    continueButtonVisibility,
    handleSaveAndNavigate,
    styles
}) => {
    if (!continueButtonVisibility) return null;

    return (
        <button className={styles.CBTbuttons} id={styles.CBTContinue} onClick={handleSaveAndNavigate}>
            Save & Continue
        </button>
    );
}

export default ContinueButton;
